
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment utiliser les publications sponsorisées sur les réseaux ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Apprenez dans ce guide à maximiser l'impact des publications sponsorisées sur les réseaux sociaux avec des stratégies ciblées pour atteindre votre audience.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Comment utiliser efficacement les publications sponsorisées sur les réseaux sociaux ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Avec plus de 3 milliards d’utilisateurs sur Facebook et plus de 750 millions de membres sur LinkedIn, les réseaux sociaux apparaissent désormais incontournables pour une entreprise voulant gagner en visibilité sur Internet, afin de développer son activité et d’accroître son chiffre d’affaires à court et long terme.",
        },
      ],
    };
  },
};
